import { Components, Theme } from '@mui/material';

export const MuiInputAdornment: Components<Theme>['MuiInputAdornment'] = {
  styleOverrides: {
    root: {
      justifyContent: 'center',
      color: 'currentcolor',
    },
  },
};
